import { useFragmentsDeliveryAPIStationConfigClientGetConfig } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useFragment } from '../../../hooks/useFragment';
import { DeliveryStatusInfo } from './DeliveryStatusInfo';

/**
 * External export tab body: shows delivery status when enabled for the station.
 * Title is omitted — the fragment tab already labels this section.
 */
export function FragmentDeliveryStatus() {
  const { fragment } = useFragment();

  const configQuery = useFragmentsDeliveryAPIStationConfigClientGetConfig(fragment.stationId);

  return (
    <QueryView
      query={configQuery}
      children={(data) => {
        return !data?.enabled ? (
          <div>
            <Alert severity="warning">
              <FormattedMessage
                id="fragments.exportStatus.externalExportNotEnabled"
                defaultMessage="El export externo no está habilitado, contacte a soporte."
              />
            </Alert>
          </div>
        ) : (
          <DeliveryStatusInfo />
        );
      }}
    />
  );
}
